<script setup lang="ts">
defineProps<{ template: 'list' | 'map' | 'split' }>()
const emits = defineEmits<{
  'change-template': [value: 'list' | 'split' | 'map']
}>()

const { t } = useI18n()
const { trackMapReduced, trackSearchMap } = useSearchTracking()

const mapReducedHandler = () => {
  trackMapReduced()
  emits('change-template', 'split')
}

const mapOpenedHandler = () => {
  trackSearchMap({ event: 'map_open' })
  emits('change-template', 'split')
}
</script>

<template>
  <BaseButton
    v-if="template === 'list'"
    class="ml-4 text-nowrap !px-3 !py-2 !text-md !font-semibold"
    color="secondary"
    has-icon
    variant="btn"
    @click="mapOpenedHandler"
  >
    <BaseIcon aria-hidden="true" class="mr-1" focusable="false" name="map" />
    {{ t('seeOnMap') }}
  </BaseButton>
  <button
    v-else-if="template === 'map'"
    class="flex flex-nowrap items-center gap-2 rounded border border-gray-200 bg-white px-3 py-2 text-xs font-medium lg:text-md"
    type="button"
    @click="mapReducedHandler"
  >
    <BaseIcon name="collapse" :size="1" />
    {{ t('collapse') }}
  </button>
</template>

<i18n lang="json">
{
  "en": {
    "collapse": "Reduce map view",
    "seeOnMap": "Map view"
  },
  "fr": {
    "collapse": "Réduire la vue carte",
    "seeOnMap": "Vue carte"
  }
}
</i18n>
